// extracted by mini-css-extract-plugin
export default {"logo":"DialogBoxResend_logo__p8YER","btn_style":"DialogBoxResend_btn_style__8eV3l","form_email":"DialogBoxResend_form_email__z60NG","btn_cancel":"DialogBoxResend_btn_cancel__q533c"};